<template>
    <div class="stage-attachment">
        <div class="flex-shrink-0">
            <svg-vue v-if="details.extension === '7zip'" class="stage-attachment-icon" icon="file-extension.7zip"/>
            <svg-vue v-else-if="details.extension === 'ace'" class="stage-attachment-icon" icon="file-extension.ace"/>
            <svg-vue v-else-if="details.extension === 'aep'" class="stage-attachment-icon" icon="file-extension.aep"/>
            <svg-vue v-else-if="details.extension === 'aepx'" class="stage-attachment-icon" icon="file-extension.aepx"/>
            <svg-vue v-else-if="details.extension === 'aet'" class="stage-attachment-icon" icon="file-extension.aet"/>
            <svg-vue v-else-if="details.extension === 'ai'" class="stage-attachment-icon" icon="file-extension.ai"/>
            <svg-vue v-else-if="details.extension === 'ait'" class="stage-attachment-icon" icon="file-extension.ait"/>
            <svg-vue v-else-if="details.extension === 'avi'" class="stage-attachment-icon" icon="file-extension.avi"/>
            <svg-vue v-else-if="details.extension === 'bmp'" class="stage-attachment-icon" icon="file-extension.bmp"/>
            <svg-vue v-else-if="details.extension === 'c'" class="stage-attachment-icon" icon="file-extension.c"/>
            <svg-vue v-else-if="details.extension === 'css'" class="stage-attachment-icon" icon="file-extension.css"/>
            <svg-vue v-else-if="details.extension === 'doc'" class="stage-attachment-icon" icon="file-extension.doc"/>
            <svg-vue v-else-if="details.extension === 'docx'" class="stage-attachment-icon" icon="file-extension.docx"/>
            <svg-vue v-else-if="details.extension === 'dotx'" class="stage-attachment-icon" icon="file-extension.dotx"/>
            <svg-vue v-else-if="details.extension === 'eps'" class="stage-attachment-icon" icon="file-extension.eps"/>
            <svg-vue v-else-if="details.extension === 'flv'" class="stage-attachment-icon" icon="file-extension.flv"/>
            <svg-vue v-else-if="details.extension === 'gif'" class="stage-attachment-icon" icon="file-extension.gif"/>
            <svg-vue v-else-if="details.extension === 'html'" class="stage-attachment-icon" icon="file-extension.html"/>
            <svg-vue v-else-if="details.extension === 'java'" class="stage-attachment-icon" icon="file-extension.java"/>
            <svg-vue v-else-if="details.extension === 'jpeg'" class="stage-attachment-icon" icon="file-extension.jpeg"/>
            <svg-vue v-else-if="details.extension === 'jpg'" class="stage-attachment-icon" icon="file-extension.jpg"/>
            <svg-vue v-else-if="details.extension === 'js'" class="stage-attachment-icon" icon="file-extension.js"/>
            <svg-vue v-else-if="details.extension === 'less'" class="stage-attachment-icon" icon="file-extension.less"/>
            <svg-vue v-else-if="details.extension === 'm4a'" class="stage-attachment-icon" icon="file-extension.m4a"/>
            <svg-vue v-else-if="details.extension === 'mid'" class="stage-attachment-icon" icon="file-extension.mid"/>
            <svg-vue v-else-if="details.extension === 'mp3'" class="stage-attachment-icon" icon="file-extension.mp3"/>
            <svg-vue v-else-if="details.extension === 'mp4'" class="stage-attachment-icon" icon="file-extension.mp4"/>
            <svg-vue v-else-if="details.extension === 'mpg'" class="stage-attachment-icon" icon="file-extension.mpg"/>
            <svg-vue v-else-if="details.extension === 'odf'" class="stage-attachment-icon" icon="file-extension.odf"/>
            <svg-vue v-else-if="details.extension === 'ods'" class="stage-attachment-icon" icon="file-extension.ods"/>
            <svg-vue v-else-if="details.extension === 'odt'" class="stage-attachment-icon" icon="file-extension.odt"/>
            <svg-vue v-else-if="details.extension === 'otp'" class="stage-attachment-icon" icon="file-extension.otp"/>
            <svg-vue v-else-if="details.extension === 'ots'" class="stage-attachment-icon" icon="file-extension.ots"/>
            <svg-vue v-else-if="details.extension === 'ott'" class="stage-attachment-icon" icon="file-extension.ott"/>
            <svg-vue v-else-if="details.extension === 'pdf'" class="stage-attachment-icon" icon="file-extension.pdf"/>
            <svg-vue v-else-if="details.extension === 'php'" class="stage-attachment-icon" icon="file-extension.php"/>
            <svg-vue v-else-if="details.extension === 'png'" class="stage-attachment-icon" icon="file-extension.png"/>
            <svg-vue v-else-if="details.extension === 'ppt'" class="stage-attachment-icon" icon="file-extension.ppt"/>
            <svg-vue v-else-if="details.extension === 'pptx'" class="stage-attachment-icon" icon="file-extension.pptx"/>
            <svg-vue v-else-if="details.extension === 'psd'" class="stage-attachment-icon" icon="file-extension.psd"/>
            <svg-vue v-else-if="details.extension === 'py'" class="stage-attachment-icon" icon="file-extension.py"/>
            <svg-vue v-else-if="details.extension === 'qt'" class="stage-attachment-icon" icon="file-extension.qt"/>
            <svg-vue v-else-if="details.extension === 'rar'" class="stage-attachment-icon" icon="file-extension.rar"/>
            <svg-vue v-else-if="details.extension === 'raw'" class="stage-attachment-icon" icon="file-extension.raw"/>
            <svg-vue v-else-if="details.extension === 'svg'" class="stage-attachment-icon" icon="file-extension.svg"/>
            <svg-vue v-else-if="details.extension === 'tga'" class="stage-attachment-icon" icon="file-extension.tga"/>
            <svg-vue v-else-if="details.extension === 'tgz'" class="stage-attachment-icon" icon="file-extension.tgz"/>
            <svg-vue v-else-if="details.extension === 'txt'" class="stage-attachment-icon" icon="file-extension.txt"/>
            <svg-vue v-else-if="details.extension === 'wav'" class="stage-attachment-icon" icon="file-extension.wav"/>
            <svg-vue v-else-if="details.extension === 'xls'" class="stage-attachment-icon" icon="file-extension.xls"/>
            <svg-vue v-else-if="details.extension === 'xlsx'" class="stage-attachment-icon" icon="file-extension.xlsx"/>
            <svg-vue v-else-if="details.extension === 'xml'" class="stage-attachment-icon" icon="file-extension.xml"/>
            <svg-vue v-else-if="details.extension === 'zip'" class="stage-attachment-icon" icon="file-extension.zip"/>
            <svg-vue v-else class="stage-attachment-icon" icon="file-extension.default"/>
        </div>
        <div class="stage-attachment-name">{{ details.name }}</div>
        <div class="stage-attachment-meta">
            <div class="stage-attachment-size">{{ $prettyBytes(details.size) }}</div>
            <button v-if="downloadButton" class="stage-attachment-action" type="button" @click="download">
                <svg-vue class="h-4 w-4" icon="font-awesome.arrow-to-bottom-light"></svg-vue>
            </button>
            <button v-if="removeButton" class="stage-attachment-action" type="button" @click="$emit('remove')">
                <svg-vue class="h-4 w-4" icon="font-awesome.times-light"></svg-vue>
            </button>
        </div>
    </div>
</template>

<script>
import {getAuthToken} from '@/utils/auth-token';

export default {
    name: "attachment",
    props: {
        details: {
            type: Object,
            required: true
        },
        downloadButton: {
            type: Boolean,
            default: true,
        },
        removeButton: {
            type: Boolean,
            default: true,
        }
    },
    methods: {
        download() {
            if (this.details.url === null) {
                window.open(this.details.download + '?token=' + getAuthToken(), '_blank');
            } else {
                window.open(this.details.download, '_blank');
            }
        }
    }
}
</script>
